import { Guid } from '../utils/guid';

export enum MessageLevel {
  ERROR,
  WARN,
  INFO,
  SUCCESS
}

export class FlashMessage {
  level: MessageLevel;
  message: string;
  // Should the message displayThroughNavigation across multiple pages?
  displayThroughNavigation: boolean;
  // Should the message automatically close?
  autoClose: boolean;
  id: string = Guid.newGuid();

  constructor(level: MessageLevel, message: string, displayThroughNavigation = false, autoClose = false) {
    this.level = level;
    this.message = message;
    this.displayThroughNavigation = displayThroughNavigation;
    this.autoClose = autoClose;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/flash-messages/flash.message.record.ts